import { IconPropsType } from '..';

export const DefaultAvatarIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width="24"
      height="24"
      rx="4"
      fill="#2E354B"
    />
    <g clipPath="url(#clip0_3425_7521)">
      <path
        d="M12 5.69995C8.52025 5.69995 5.70001 8.52019 5.70001 12C5.70001 15.4797 8.52025 18.3 12 18.3C15.4798 18.3 18.3 15.4797 18.3 12C18.3 8.52019 15.4798 5.69995 12 5.69995ZM12 8.84995C12.9787 8.84995 13.7719 9.64336 13.7719 10.6218C13.7719 11.6003 12.9795 12.3937 12 12.3937C11.0215 12.3937 10.2281 11.6003 10.2281 10.6218C10.2281 9.64336 11.0206 8.84995 12 8.84995ZM12 16.725C10.6974 16.725 9.51693 16.1951 8.66052 15.3397C9.05919 14.3108 10.0436 13.575 11.2125 13.575H12.7875C13.9574 13.575 14.9418 14.3103 15.3395 15.3397C14.4831 16.1958 13.3018 16.725 12 16.725Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3425_7521">
        <rect
          width="14"
          height="14"
          fill="white"
          transform="translate(5 5)"
        />
      </clipPath>
    </defs>
  </svg>
);
